import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { Method } from "@inertiajs/core"
import Chevron from "bonza-shared/js/components/icons/chevron"
import { User } from "bonza-shared/js/types/UserClass"
import defaultAvatar from "@img/defaultAvatar.png"

export type UserDropdownOption = {
    name: string
    method?: Method
    as?: string
    onClick?: () => void
}
type UserDropdownProps = {
    options: UserDropdownOption[]
    user: User
    className?: string
}

export default function UserDropdown({
    options,
    user,
    className,
}: UserDropdownProps) {
    return (
        <Menu>
            <MenuButton
                data-active
                className={`
                    group flex h-11 flex-row items-center gap-2 rounded-full
                    bg-bonza-dark-bg p-1.5 pr-3

                    hover:bg-bonza-dark-bg2

                    ${className}
                `}
            >
                <div
                    className={`
                        relative aspect-square h-full items-center
                        justify-center overflow-hidden rounded-full
                    `}
                >
                    <img
                        className={`h-full w-full rounded-full object-cover`}
                        data-tooltip-target="tooltip"
                        src={user?.avatar ?? defaultAvatar}
                    />
                </div>
                <span className={"mr-2 max-w-[150px] truncate text-sm"}>
                    {user.name}
                </span>
                <Chevron
                    className={`
                        size-4 rotate-90 transition-all duration-100 ease-in-out

                        group-data-[open]:-rotate-90
                    `}
                />
            </MenuButton>
            <MenuItems
                anchor="bottom end"
                transition
                className={`
                    mt-1 flex w-52 origin-top-right flex-col rounded-xl border
                    border-bonza-dark bg-bonza-dark-semi p-1 text-sm/6
                    text-bonza-pale z-[999] transition duration-200 ease-in-out

                    data-[closed]:-translate-y-1 data-[closed]:opacity-0

                    focus:outline-none
                `}
            >
                {options.map(({ name, ...opt }) => (
                    <MenuItem key={`menu-${name}`}>
                        <button
                            className={`
                                flex w-full items-center rounded-lg px-3 py-1.5

                                data-[focus]:bg-bonza-dark
                            `}
                            {...opt}
                        >
                            {name}
                        </button>
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    )
}
